__turbopack_context__.v({
  "actionCard": "styles-module-scss-module__Fl_teW__actionCard",
  "honeypot": "styles-module-scss-module__Fl_teW__honeypot",
  "infoPage": "styles-module-scss-module__Fl_teW__infoPage",
  "privacyActions": "styles-module-scss-module__Fl_teW__privacyActions",
  "quickLinks": "styles-module-scss-module__Fl_teW__quickLinks",
  "textContent": "styles-module-scss-module__Fl_teW__textContent",
});
